import styles from "./upscori.module.css";
import NextSaturdayInput from "./Saturdayinputdate.js";
import ReCAPTCHA from "react-google-recaptcha";
import {createUser}  from "../../components/Service/UPSCorentation.js";
import dynamic from 'next/dynamic';
//import 'react-datepicker/dist/react-datepicker.css';
const Otpverification = dynamic(()=>import("../../components/Modal/Otpverification"));
import { useState } from "react";

const Upscori_form = () => {

  const[verified,setverified] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [modalOtp, setModalOtp] = useState(false);
  const [modalOtpstatus, setmodalOtpstatus] = useState(null);
  const [valuephno, setvaluephno] = useState(undefined);
  const [captchaerror, setcaptchaerror] = useState(undefined);
  
  // start datepicker
   function convertJsonStringToNumber(jsonString) {
    // Parse the JSON string to an object
    const jsonObject = JSON.parse(jsonString);
  
    // Iterate over the keys and convert numeric strings to numbers
    for (const key in jsonObject) {
      if (jsonObject.hasOwnProperty(key)
&& !isNaN(jsonObject[key])) {
        jsonObject[key] = Number(jsonObject[key]);
      }
    }
  
    return jsonObject;
  }
  

  function onChange(value) {
    if(value==null){
      setverified(false);
    }
    else{
      setverified(true);
    }
  }

  async function handleOnSubmit(e) {
  e.preventDefault();
  if(verified){
    const formData = {};
    formData['formType']="upsc orientation program 2026";
    formData['title']="upsc orientation program 2026";
    Array.from(e.currentTarget.elements).forEach((field) => {
      if (!field.name) return;
      formData[field.name] = field.value;
    });
    formData['countryCode'] = "+91"; 
    formData['phoneNo']= formData['phoneNo'].substring(formData['phoneNo'].indexOf(' ') + 1).trim().replace(/[^0-9]/g, "");
    console.log(formData);
      formData['phoneNo'] = convertJsonStringToNumber(formData['phoneNo']);
      const transform={fields:{...formData}};
      console.log(transform);
    setIsLoading(true);
    createUser(transform)
    .then(response =>{
        setModalOtp(true);
        
        setmodalOtpstatus(response.message); 

        window.grecaptcha.reset(setverified);
        setverified(false);
        setvaluephno(undefined);
        document.getElementById("orientationform").reset();
        setIsLoading(false);
    })
    .catch(error=>{
        setModalOtp(true);
        setmodalOtpstatus("failure"); 
        window.grecaptcha.reset(setverified);
        setverified(false);
        setIsLoading(false);
    }) 
    }
    else{    
      setcaptchaerror(true);
      setTimeout(() => { 
      setcaptchaerror(false);
      }, 3000);
    }
  }

  return(
  <> 
    {isLoading && 
    <div className="APIPreLoader" id="APIPreLoader">
        <div className="loader">Loading...</div>
    </div>
    }
    <Otpverification show={modalOtp} title={modalOtpstatus} frompage="upsc orientation program 2026" onHide={() => setModalOtp(false)} />
    <div className="container-fluid pt-3">
      <div className="row mx-auto pt-3" style={{background: "#FFF2F2 0% 0% no-repeat padding-box" , opacity: "1"}}>
        <div className="container pt-4 ">
          <div className="row">
            <div className="col-md-10 col-12 mx-auto">
              <p className={`${styles.contactheader} mb-md-0`}>Orientation Registration Form</p>
              <p className={`${styles.acheiverrank} `} style={{color:"#DB1B0D"}}>Kindly post your queries in the below form. We will get in touch with you shortly.</p>
              <form  onSubmit={handleOnSubmit} id="orientationform" autoComplete="off">
                <div className="row pt-4">
                  <div className="col-12 col-xl-3 col-lg-4 col-md-6">
                    <div className="mb-4">
                      <input type="text" className={`${styles.acheiverrank} form-control`}  autoComplete="off"  name="name" placeholder="Name"  required minLength={1}  /> 
                    </div>
                  </div>

                  <div className="col-12 col-xl-3 col-lg-4 col-md-6">
                    <div className="mb-4">
                      <input type="email" className={`${styles.acheiverrank} form-control`} title="Please enter a valid email address" placeholder="Email Address" autoComplete="off" name="emailAddress" pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$" aria-describedby="emailHelp" required/>
                    </div>
                  </div>

                  <div className="col-12 col-xl-3 col-lg-4 col-md-6">
                    <div className="mb-4">
                    <input type="tel" className={`${styles.acheiverrank} form-control`} name="phoneNo" placeholder="Phone No" pattern="[0-9]{10}" maxlength="10" required />
                    </div>
                  </div>
                  
                  <div className="col-12 col-xl-3 col-lg-4 col-md-6">
                    <div className="mb-4">
                      <input type="text" className={`${styles.acheiverrank} form-control`} autoComplete="off" placeholder="Qualification" name="qualification" minLength="1" required/>
                    </div>
                  </div>

                  {/* <div className="col-12 col-xl-3 col-lg-4 col-md-6">
                    <div className="mb-4">
                        <select className={`${styles.acheiverrank} form-select form-control`} id="autoSizingSelect prelimform"  name="branch" autoComplete="off" placeholder="Years of Experience"  required>
                            <option value="" disabled selected hidden>Select Center</option>
                            <option value="Chennai">Chennai Annanagar</option>
                            <option value="Online">Online</option>
                          
                        </select>
                    </div>
                  </div> */}
              
                  <div className="col-12 col-xl-3 col-lg-4 col-md-6">
                    <div className="mb-4">
                        <select className={`${styles.acheiverrank} form-select form-control`} id="autoSizingSelect prelimform"  name="mode" autoComplete="off"  required>
                            <option value="" disabled selected hidden>Select Mode</option>
                            <option value="Offline">Offline</option>
                            <option value="Online">Online</option>
                        </select>
                    </div>
                  </div>
                {/* <div className="col-12 col-xl-3 col-lg-3 col-md-3">
                    <div className="mb-4">
                        <select className={`${styles.acheiverrank} form-select form-control`} id="autoSizingSelect prelimform"  name="timeSlot" autoComplete="off"  required>
                            <option value="" disabled selected hidden>Select timing</option>
                            <option value="11 AM">11 AM</option>
                            <option value="02 PM">02 PM</option>
                            <option value="06 PM">06 PM</option>
                        </select>
                    </div>
                 </div> */}

                  <div className="col-12 col-xl-4 col-lg-4 col-md-6">
                    <div className="row mb-4">
                      <div className="col-12 col-xl-5 "><label className="align-middle" style={{color:"#DB1B0D"}}>Appointment Time:</label></div>
                      <div className="col-12 col-xl-6">
                        <input type="text" className={`${styles.acheiverrank} form-control`} autoComplete="off" Value="07:00 PM" readOnly  name="timeSlot" required/>
                      </div>
                    </div>
                  </div>
                
                    {/*<div className="col-12 col-xl-3 col-lg-4 col-md-6">
                          <div className="mb-4">
                          <DatePicker
                              selected={selectedDate}
                              onChange={handleDateChange}
                              excludeDates={excludedDates}
                              minDate={minDate}
                              maxDate={maxDate}
                              dateFormat="MM/dd/yyyy"
                              name="appointmentdate"
                              placeholderText={'DateAppointmentdate'}
                              className="form-control"
                              required
                              showIcon
                              toggleCalendarOnIconClick
                            />
                          </div>
                        </div>
                      */}
                                  
                    <div className="col-12 col-xl-3 col-lg-4 col-md-6">
                      <div className="row">
                        <div className="col-12 col-xl-6"><label className="align-middle danger" style={{color:"#DB1B0D"}}>Orientation Date:</label></div>
                        <div className="col-12 col-xl-6">
                          {/* <input type="text" className={`${styles.acheiverrank} form-control`} autoComplete="off" Value="11-07-2026" readOnly  name="dateofappointment" required/> */}
                          <NextSaturdayInput />
                          </div>
                      </div> 
                    </div>

                  <div className="col-12">
                    <div className="form-check">
                        <input className="form-check-input ps-3" type="checkbox" value="" id={styles.invalidCheck2} />
                        <label className={`${styles.checkboxcontent} form-check-label`}  htmlFor="invalidCheck2">
                            I would like to receive updates from Shankar IAS Academy
                        </label>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12 col-md-5">
                  <div className="d-flex flex-wrap mb-3">
                  <div className="me-3 mt-2">
                  <ReCAPTCHA className={`${styles.captcha}`}
                  sitekey="6LcnfZ0lAAAAAJgHlHwqnKD926Gcgu6jlrHRgMQI"     
                  onChange={onChange}
                  />
                            <div className="">
                              {captchaerror && <div className="text-danger text-center captachafont">Please verify the captcha!</div>}
                            </div>
                  </div>

                  <div className="my-auto">
            
                  <p className="mt-3"><button className={`${styles.normalbutton}`} type="submit">Send</button></p> 
                  </div>
                  </div>
                    </div>
                    <div class="col-12 col-md-7" style={{color:"#DB1B0D",fontSize:14}}>*Offline - (Door No 18, Old plot No 109, New plot No 259, AL Block, 4th Avenue, Shanthi Colony,<br/> Anna Nagar, Chennai-600 040.)</div>
                  </div>
                </div>
              </form>   
            </div>
          </div>
        </div>  
      </div>
    </div>
  </>
)
}
export default Upscori_form;